import { useEffect, useState } from 'react';

import { getDeactivationReasons } from '../../api/services/DeactivateRider';

interface IUseDeactivateReason {
  deactivateReasons: { label: string; value: string }[];
}

export const useDeactivateReason = (): IUseDeactivateReason => {
  const [deactivateReasons, setDeactivateReasons] = useState<{ label: string; value: string }[]>([]);

  useEffect(() => {
    const abortController = new AbortController();

    async function fetchDeactivateReasons() {
      const response = await getDeactivationReasons(abortController.signal);

      if (response?.type === 'success' && response.data.reasons?.length > 0) {
        setDeactivateReasons(response.data.reasons);
      }
    }
    fetchDeactivateReasons();
  }, []);

  return { deactivateReasons };
};
